import cvEs from '@/assets/cv-es.json'
import cvEn from '@/assets/cv-en.json'
import stringsEs from '@/assets/strings-es.json'
import stringsEn from '@/assets/strings-en.json'

export default {
    en: {
        strings: stringsEn,
        cv: cvEn
    },
    es: {
        cv: cvEs,
        strings: stringsEs
    }
}
